import { render, staticRenderFns } from "./inssAddModal.vue?vue&type=template&id=c06e4e66"
import script from "./inssAddModal.vue?vue&type=script&lang=js"
export * from "./inssAddModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports